import { serverFetcher } from '@instance';
import routes from '@config/routes';

export const getOrdersReport = async (token) => {
  try {
    return await serverFetcher(routes.ordersReport, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    return [];
  }
};

export const getUsersReport = async (token) => {
  try {
    return await serverFetcher(routes.usersReport, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    return [];
  }
};

export const getUsersKpiReport = async ({
  token,
  startDate,
  endDate,
}: {
  token?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    const query = new URLSearchParams();

    if (startDate) {
      query.set('startDate', startDate);
    }

    if (endDate) {
      query.set('endDate', endDate);
    }

    const url = query.size
      ? `${routes.usersKpiReport}?${query.toString()}`
      : routes.usersKpiReport;

    return await serverFetcher(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    return {
      newUsers: 0,
      newAgents: 0,
      newAgencies: 0,
    };
  }
};

export const postVisit = async (isAuthenticated) => {
  try {
    return await serverFetcher(routes.postVisit, {
      method: 'POST',
      body: {
        isAuthenticated,
      },
    });
  } catch (err) {
    return [];
  }
};
